<script lang="ts">
    import { Link } from "svelte-navigator";
    import { appManager } from "../AppManager";
    import type { ProjectDetailsData } from "../api/projects/data/projects/ProjectDetailsData";

    export let project: ProjectDetailsData;
    export let scenarioIndex: number;

    let scenario = project.scenarios[scenarioIndex];

    let url = `scenario/${scenario.id}`;
    $: if (typeof project !== "undefined") {
        scenario = project.scenarios[scenarioIndex];
        url = `scenario/${scenario.id}`;
    }

    let canOpenProject = true;
    appManager.getCanOpenProjects().subscribe((id) => {
        canOpenProject = id;
    })
</script>

{#if canOpenProject}
    <Link to={url}
        ><button
            title={scenario.name}
            class="btn btn-small badge badge-hover badge-scenario"
            >{scenario.functionalName}</button
        ></Link>
{:else}
    <div class="d-inline">
        <button
            title={scenario.name}
            class="btn btn-small badge badge-hover badge-scenario disabled"
            >{scenario.functionalName}</button>
    </div>
{/if}

<style>
    button {
        height: 20px;
        margin: 2px;
    }

    .badge-scenario {
        background-color: #ffc926;
        color: #000;
    }

    .badge-hover:hover {
        box-shadow: 1px 1px 5px gray;
    }

    .btn:hover {
        color: white;
    }
</style>
